import {Injectable} from '@angular/core';
    import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {PageProjectAnalysisStepsComponent} from '../../pages';

@Injectable({
    providedIn: 'root'
})
export class ProjectDetailsAutosaveGuard {
    canDeactivate(
        component: PageProjectAnalysisStepsComponent,
        currentRoute: ActivatedRouteSnapshot,
        _currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): Promise<boolean> {
        const projectId = currentRoute.paramMap.get('projectId');
        const staysOnSameProject = !!nextState?.url.startsWith(`/projecten/${projectId}/step/`);

        return component.flushProjectSave(!staysOnSameProject);
    }
}
